import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { JhiAlertService, JhiEventManager } from 'ng-jhipster';

import { Account, Faculty } from '../../../../models';
import { AlertUtils } from '../../../../shared';
import { FACULTY_LIST_MODIFICATION } from '../../../../shared/constants';
import { Principal } from '../../../../services';

@Component({
    selector: 'qms-queues-handling-navigation-menu',
    templateUrl: './queues-management-navigation-menu.component.html'
})
export class QueuesManagementNavigationMenuComponent implements OnInit, OnDestroy {

    @Input()
    public onlyCategoryQueues: boolean;

    public faculties: Array<Faculty>;

    private facultySubscription: Subscription;
    private currentAccount: Account;

    constructor(private principal: Principal,
                private eventManager: JhiEventManager,
                private alertService: JhiAlertService) {
        this.faculties = [];
        this.onlyCategoryQueues = false;
    }

    ngOnInit() {
        this.reloadUserAndLoadFaculties();
        this.registerChangeInFaculties();
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.facultySubscription);
    }

    private reloadUserAndLoadFaculties() {
        this.principal.identity(true).then((account) => {
            this.currentAccount = account;
            this.loadFaculties();
        });
    }

    private loadFaculties() {
        this.principal.userFaculties().subscribe((faculties: Faculty[]) => {
            this.faculties = faculties;
        });
    }

    private registerChangeInFaculties() {
        this.facultySubscription = this.eventManager.subscribe(FACULTY_LIST_MODIFICATION, (response) => {
            this.reloadUserAndLoadFaculties();
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/management-navigation-menu/queues-management-navigation-menu/queues-management-navigation-menu.component.ts